/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const BlurbTemplatesMapping = {
  "": "default",
  blurb1: "default",
  blurb2: "withBorder",
  blurb3: "default"
};

export const BlockQuoteTemplatesMapping = {
  "": "default",
  "block-quote-1": "withBackground",
  "block-quote-2": "withBorder"
};

export const BlockQuoteIconType = {
  "": "curveIcon",
  "block-quote-1": "edgeIcon",
  "block-quote-2": "edgeIcon"
};

export const QATemplatesMapping = {
  "q-and-a-element-default": "default",
  "q-and-a-element-1": "default",
  "q-and-a-element-2": "withAuthorImage"
};

export const QuestionTemplatesMapping = {
  "question-element-default": "default",
  "question-element-1": "default",
  "question-element-2": "withAuthorImage"
};

export const AnswerTemplatesMapping = {
  "answer-element-default": "default",
  "answer-element-1": "withAuthorImage"
};

export const SummaryTemplatesMapping = {
  "": "header",
  border: "border",
  simple: "default"
};

export const AlsoReadTemplatesMapping = {
  default: "textLeftAlign",
  vertical: "default",
  rightAlign: "imageRightAlign"
};

export const QuoteTemplatesMapping = {
  default: "borderNone",
  "quote-1": "borderLeft",
  "quote-2": "borderTopSmall"
};
